import * as React from 'react';
import AntTooltip, { TooltipProps as AntTooltipProps } from 'antd/lib/tooltip';
import './Tooltip.less';
import Styles from './Tooltip.module.less';

export type TooltipProps = AntTooltipProps;

export const Tooltip = (props: TooltipProps): JSX.Element => {
    return <AntTooltip {...props} prefixCls={Styles.tooltip} />;
};
